if (!customElements.get('tah-santa-volume')) {
  customElements.define('tah-santa-volume', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.quantity = this.root.querySelector('input[name="quantity"]');
      this.cards = [...this.querySelectorAll('[data-min]')];
      this.savedQuantity = this.quantity?.value || '1';
      this.onUpdate = event => {
        this.quantity = this.root.querySelector('input[name="quantity"]');
        if (event.type === 'variant:changed' && this.quantity) this.quantity.value = this.savedQuantity;
        else if (event.target === this.quantity) this.savedQuantity = this.quantity.value;
        this.update();
      };
      this.onClick = event => {
        const card = event.target.closest('button[data-min]');
        this.quantity = this.root.querySelector('input[name="quantity"]');
        if (!card || !this.quantity) return;
        const quantity = Number(this.quantity.value) || 1;
        const minimum = Number(card.dataset.min);
        const maximum = Number(card.dataset.max) || Infinity;
        if (quantity < minimum || quantity > maximum) {
          this.quantity.value = String(minimum);
          this.quantity.dispatchEvent(new Event('input', {bubbles:true}));
          this.quantity.dispatchEvent(new Event('change', {bubbles:true}));
        }
        this.update();
      };
      this.addEventListener('click', this.onClick);
      this.root.addEventListener('input', this.onUpdate);
      this.root.addEventListener('change', this.onUpdate);
      document.addEventListener('variant:changed', this.onUpdate);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.root?.removeEventListener('input', this.onUpdate);
      this.root?.removeEventListener('change', this.onUpdate);
      document.removeEventListener('variant:changed', this.onUpdate);
    }
    update() {
      this.quantity = this.root.querySelector('input[name="quantity"]');
      const style = this.root.querySelector('select[name="options[Style]"]')?.value;
      const type = style === 'Personalized' ? 'personalized' : 'plain';
      const quantity = Number(this.quantity?.value) || 1;
      for (const card of this.cards) {
        const active = quantity >= Number(card.dataset.min) && quantity <= (Number(card.dataset.max) || Infinity);
        const pressed = String(active);
        if (card.getAttribute('aria-pressed') !== pressed) card.setAttribute('aria-pressed', pressed);
        const price = card.querySelector('[data-volume-price]');
        const text = '$' + card.dataset[type];
        if (price.textContent !== text) price.textContent = text;
      }
    }
  });
}